<template>
    <v-autocomplete
        v-model="internalValue"
        :class="buttonClass"
        :items="users"
        item-value="id"
        :item-text="(item) => { return !this._.isNil(item.name) && item.name.length ? item.name : item.email }"
        placeholder="Selecteaza utilizator"
        multiple
        single-line
    >
        <template v-slot:selection="{ item, index }">
            <v-chip :style="{height: '24px'}" v-if="index === 0">
                <span>{{ (!_.isNil(item.name) ? item.name : item.email) }}</span>
            </v-chip>
            <span :style="{height: '24px'}" v-if="index === 1" class="grey--text caption">
              (+{{ internalValue.length - 1 }} utilizatori)
            </span>
        </template>
    </v-autocomplete>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const { mapGetters } = createNamespacedHelpers("filter");
    export default {
        props: {
            value: {
                type: Array,
                default () {
                    return null
                }
            },
            buttonClass: {
                type: [String, Array, Object],
                default() {
                    return ''
                }
            },
            filterByRole: {
                type: String,
                default() {
                    return undefined
                }
            }
        },
        computed: {
            ...mapGetters({
                getUser: "getUser"
            })
        },
        data: function () {
            return {
                users: [],
                internalValue: this.value
            }
        },
        watch: {
            internalValue: {
                handler (val) {
                    this.$store.commit('filter/setUser', val)
                    this.$emit('input', val)
                }
            }
        },
        async mounted() {
            if (typeof(this.filterByRole) === 'string' && this.filterByRole.length) {
                this.users = await this.$db.Employee
                    .where('hasRoles', [this.filterByRole, 'admin'].join('|'))
                    .where('active', 1)
                    .limit(500)
                    .get()
                    .then(({data}) => data)
            } else {
                this.users = await this.$db.Employee
                    .where('active', 1)
                    .limit(500).get()
                    .then(({data}) => data)
            }
            let userIds = this.users.map(u => u.id)
            let usersFromStore = this.getUser(this.value, [])
            this.internalValue = usersFromStore.filter((i) => {
                return userIds.indexOf(i) >= 0
            })
        }
    }
</script>
